var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('ProductFinder',{attrs:{"forceLoading":_vm.productId && !_vm.loaded,"remove-price":true,"uneditable-product-qty-skus":_vm.oldProductSkus},model:{value:(_vm.products),callback:function ($$v) {_vm.products=$$v},expression:"products"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }